import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "w-full overflow-hidden rounded-lg border border-[#F1C21B] bg-[#FEF9E7] text-textPrimary",
  role: "alert"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "flex-1 text-sm font-bold" }
const _hoisted_4 = { class: "font-normal whitespace-nowrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-px mx-4 mb-3 bg-[#F1C21B]" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "mx-3 mb-3 rounded-md bg-white px-3 py-2",
  "data-testid": "post-station-reverted-callout-justification"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Justificativa da reversão", -1)
const _hoisted_8 = { class: "text-sm whitespace-pre-line" }
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-xs text-[#666]"
}

import { computed, ref } from 'vue'
import { mdiAlertCircle, mdiChevronDown } from '@mdi/js'

import SVGIcon from '@/components/SVGIcon.vue'
import type { PostStationReversion } from '@/Network/Types/Responses/PostStationResponses'
import { formatDateTimeWithOffset } from '@/utils/date'

const CALLOUT_TITLE = 'Validação de pós-plantão revertida.'

// `justification` é nullable no contrato (coluna `note`, `text NULL`): sem
// fallback o bloco expandido apareceria vazio.
const NO_JUSTIFICATION_TEXT = 'Nenhuma justificativa foi registrada nesta reversão.'


export default /*#__PURE__*/_defineComponent({
  __name: 'PostStationRevertedCallout',
  props: {
    reversion: {},
    timezone: {}
  },
  setup(__props: any) {

const props = __props;



// Texto do RF-23. Em constante para o prettier não quebrar a linha no template.
const isExpanded = ref(true)

const toggle = () => {
  isExpanded.value = !isExpanded.value
}

// Fuso explícito no texto (`UTC-3`) porque a reversão pode ser feita por alguém
// em outro fuso que o do plantão.
const formattedRevertedAt = computed(() =>
  formatDateTimeWithOffset(props.reversion.revertedAt, props.timezone ?? '')
)

const justificationText = computed(() => props.reversion.justification || NO_JUSTIFICATION_TEXT)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "flex w-full items-start gap-2 px-3 py-2 text-left",
      "aria-expanded": isExpanded.value,
      "aria-controls": "post-station-reverted-callout-justification",
      "data-testid": "post-station-reverted-callout-header",
      onClick: toggle
    }, [
      _createVNode(SVGIcon, {
        path: _unref(mdiAlertCircle),
        class: "mt-0.5 h-4 w-4 shrink-0 text-[#F1C21B]"
      }, null, 8, ["path"]),
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(CALLOUT_TITLE) + " "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(formattedRevertedAt.value), 1)
      ]),
      _createVNode(SVGIcon, {
        path: _unref(mdiChevronDown),
        class: _normalizeClass(["h-5 w-5 shrink-0 transition-transform duration-200", isExpanded.value ? 'rotate-180' : 'rotate-0'])
      }, null, 8, ["path", "class"])
    ], 8, _hoisted_2),
    _hoisted_5,
    _createElementVNode("div", {
      id: "post-station-reverted-callout-justification",
      class: _normalizeClass(["overflow-hidden transition-[max-height] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]", isExpanded.value ? 'max-h-96' : 'max-h-0'])
    }, [
      (isExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(justificationText.value), 1),
            (_ctx.reversion.revertedBy)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Revertido por " + _toDisplayString(_ctx.reversion.revertedBy.name), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})